<template>
    <component
        :is="buttonComponent"
        class="button-videos"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        :to="buttonRoute"
        @click="buttonClick(buttonClickParams)"
    >
        {{ buttonText }}
    </component>
</template>

<script>
export default {
    name: 'ButtonVideos',
    props: {
        buttonColor: {
            required: false,
            type: String,
            default:
                'shadow-inner-md border border-zinc-400 bg-zinc-300 text-zinc-900 hover:border-zinc-500 focus-visible:outline-zinc-600',
        },
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        buttonComponent() {
            return this.buttonRoute ? 'router-link' : 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['inline-block'] = true;
            cls['px-3 py-2'] = true;
            cls['rounded-md shadow-xs'] = true;
            cls['cursor-pointer'] = true;
            cls['focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['text-base font-medium'] = true;
            cls[this.buttonColor] = true;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
};
</script>
